import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, Validators } from '@angular/forms';
import intlTelInput, { Iti } from 'intl-tel-input';


@Component({
  selector: 'nw-phone-number',
  templateUrl: './phone-number.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`.iti {
    display: block !important;
  }`]
})
export class PhoneNumberComponent implements OnChanges, AfterViewInit {
  @ViewChild('PhoneNumber') phoneNumberRef!: ElementRef;

  iti!: Iti;
  control = new FormControl();
  @Input() name = 'PhoneNumber';
  @Input() phoneNumber?: string = undefined;
  @Input() inputRequired: boolean = false;
  @Input() isReadonly: boolean = false;
  @Input() additionalPlaceholder?: string;
  @Input() cssClass: string = 'form-control';
  @Output() phoneNumberChange: EventEmitter<string> = new EventEmitter<string>();

  internalPhoneNumber?: string;
  internalPlaceHolder?: string;

  get errors(): ValidationErrors | null {
    return this.control.errors;
  }

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if(!changes['inputRequired']) {
      return;
    }
    if(changes['inputRequired'].currentValue && !this.control.hasValidator(Validators.required)) {
      this.control.addValidators([Validators.required]);
    } else this.control.removeValidators([Validators.required]);
  }

  ngAfterViewInit(): void {


    setTimeout(() => {
      const input = this.phoneNumberRef.nativeElement;
      this.iti = intlTelInput(input, {
        initialCountry: "se",
        separateDialCode: true,
      });

      if (this.phoneNumber) {
        this.iti.setNumber(this.phoneNumber);
        this.control.setValue(input.value);
      }

      input.addEventListener("countrychange", () => {
        this.onPhoneNumberChange();
      });
    }, 100);
  }

  onPhoneNumberChange(event?: Event) {

    var phoneNumber = (<any>this.iti)._getFullNumber();
    //console.log(this.iti.isValidNumber());
    phoneNumber.replace(' ', '');
    this.control.setValue(event ? (event.target as HTMLInputElement).value : undefined);
    this.phoneNumberChange.emit(phoneNumber);
  }

}
